// Clinic Configuration for Dentist in Winston Salem
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Winston Salem",
  clinicId: "dentistinwinston-salem",
  clinicUrl: "https://dentistinwinston-salem.com",
  // Contact Information
  phoneNumber: "336-802-1894",
  phoneNumberRaw: "+13368021894", // For tel: and sms: links
  email: "dentalcare@dentistinwinston-salem.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinwinston-salem&agentId=3d5d7985-a53d-48fd-855c-32599e708fd4",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinwinston-salem/voice",

  // Location
  address: "3210 Silas Creek Pkwy, Suite-4 Winston salem, NC, 27103, United States",
  addressShort: "3210 Silas Creek Pkwy, Suite-4 Winston salem, NC, 27103",
  city: "Winston Salem",
  hcity: "Winston-Salem",
  state: "North Carolina",
  stateShortForm: "NC",
  PostalCode: "27103",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/4suC6tWA6KLeT8HY7",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12261.60871104759!2d-80.293994!3d36.06981!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8853b0396fb5de8d%3A0xedee848578dd5f76!2sDentist%20in%20Winston%20Salem!5e1!3m2!1sen!2sin!4v1756795485215!5m2!1sen!2sin',
  iframeTitle: "Dentist in Winston Salem",

  //membership
  membership: "https://member.kleer.com/?slug=RE6D",

  // Sunbit
  sunbitUrl: "https://dentistinwinston-salem.com/patient-portal",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-winstonsalem?utm_source=practice&utm_medium=email&m=65964",


  // Analytics
  gaMeasurementId: "G-CEBRDY7H94",
  clarityProjectId: "pvgkbe95f9",

  // Google Ads — direct conversion tracking
  googleAdsId: "AW-17121681701",
  googleAdsConversions: {
    // Primary — used for Smart Bidding optimization
    "phone_call_click": "AW-17121681701/g0iaCLa1w5QcEKXCoOQ_",
    "contact_form_success": "AW-17121681701/I4thCNqzroYcEKXCoOQ_",
    "call_back_success": "AW-17121681701/sY7HCOWet4YcEKXCoOQ_",
    "chatbot_phone_click": "AW-17121681701/mw-eCMzNt5QcEKXCoOQ_",
    "chatbot_voice_call": "AW-17121681701/k825CPm_w5QcEKXCoOQ_",
    "book_appointment_success": "AW-17121681701/8CTcCP2twoYcEKXCoOQ_",
    "Confirm-Booking": "AW-17121681701/wpwsCKDOt5QcEKXCoOQ_",
    "Submit-Payment": "AW-17121681701/pVYNCKHMt5QcEKXCoOQ_",
    // Secondary — observation/reporting only
    "sms_click": "AW-17121681701/5ej4CMDNt5QcEKXCoOQ_",
    "directions_click": "AW-17121681701/9PoKCK-3w5QcEKXCoOQ_",
    "email_click": "AW-17121681701/mvO8CNLNt5QcEKXCoOQ_",
    "map_click": "AW-17121681701/c8TsCK_Ot5QcEKXCoOQ_",
    "social_media_click": "AW-17121681701/khnbCM-2w5QcEKXCoOQ_",
    "financing_click": "AW-17121681701/wYJ_CLDPt5QcEKXCoOQ_",
    "membership_click": "AW-17121681701/BUcCCJTOt5QcEKXCoOQ_",
    "outbound_link_click": "AW-17121681701/1MlFCNvNt5QcEKXCoOQ_",
    "chat_send": "AW-17121681701/znSBCO7Rt5QcEKXCoOQ_",
    "chatbot_quick_action": "AW-17121681701/bQ3VCLy1w5QcEKXCoOQ_",
    "chatbot_insurance_upload": "AW-17121681701/dFZnCPfRt5QcEKXCoOQ_",
  } as Record<string, string>,

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinwinston-salem",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinwinston-salem",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinwinston-salem",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinwinston-salem.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistinWinstonSalem",
    instagram: "https://www.instagram.com/dentistin_winstonsalem/",
    twitter: "https://x.com/DentistSalemNC",
    linkedin: "https://www.linkedin.com/company/dentist-in-winston-salem/",
    youtube: "https://www.youtube.com/@DentistinWinstonSalem",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/6725517948498622730/profile?hl=en-GB&fid=17144786540239347574",
    facebook: "https://www.facebook.com/DentistinWinstonSalem",
    yelp: "",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 12,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 10,
      AppointmentTypeNum: 5
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 12,
      AppointmentTypeNum: 8
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 12,
      AppointmentTypeNum: 7
    }
  ],


  // Twilio Configuration
  twilioPhoneNumber: "13367293574",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;  
